import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { makeStyles } from "tss-react/mui";

import { FormValues } from "@/utils/type";

interface Props {
  value?: string;
  onSubmit?: (value: string) => void;
  onDelete?: () => void;
  autoFocus?: boolean;
}

const MealCommentField: React.FC<Props> = ({
  value = "",
  onSubmit = () => {},
  onDelete,
  autoFocus,
}) => {
  const { classes } = useStyles();
  const { register, reset, handleSubmit } = useForm({
    defaultValues: {
      comment: value,
    },
  });
  const _onSubmit = (values: FormValues<typeof handleSubmit>) => {
    onSubmit(values.comment);
    reset({ comment: "" });
  };

  return (
    <TextField
      {...register("comment")}
      className={classes.root}
      placeholder="Write comments"
      size="small"
      multiline
      fullWidth
      autoFocus={autoFocus}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          handleSubmit(_onSubmit)();
        }
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment className={classes.adornment} position="end">
            <IconButton
              color="primary"
              onClick={handleSubmit(_onSubmit)}
              size="small"
            >
              <SendIcon className={classes.sendIcon} />
            </IconButton>
            {onDelete && (
              <IconButton color="error" onClick={onDelete} size="small">
                <DeleteIcon className={classes.sendIcon} />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

const useStyles = makeStyles()({
  root: {
    "& .MuiInputBase-root": {
      fontSize: 14,
      fontWeight: 600,
    },
  },
  adornment: {
    marginRight: -8,
  },
  sendIcon: {
    fontSize: 16,
  },
});

export default MealCommentField;
